var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 28.5A12.5 12.5 0 1 0 3 16a12.512 12.512 0 0 0 12.5 12.5zm-4.293-10.216 3.471-2.695V8.302a.822.822 0 1 1 1.643 0V16a.82.82 0 0 1-.32.649l-3.787 2.933a.823.823 0 0 1-1.302-.755.82.82 0 0 1 .295-.543z",
    fill: "#FFE14B",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.3b8b7d35a0400557933735ef95b97581.svg";
export { ForwardRef as ReactComponent };